<!--- COMPONENTE PCPartidasActivasYRecientesLineaSinAsociacionPedido  ---->
<!---
Descripción del componente:
---------------------------
- Incluye una lista con las partidas activas y las finalizadas recientemente de una linea de producción.

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div class="main-pcPartirasActivasYRecientesLineaConAsociacionPedido">
    <UCPreload :show="mostrarPrecarga" />
    <div>
      <div
        v-for="penPV in partidasEnPuntoDeVolcado"
        :key="penPV.Id"
        class="content-partida"
      >
        <div
          class="content-partida-item padding-half"
        >
          <!-- <pre> {{ penPV }} </pre> -->
          <div class="content-title-line">
            <div class="content-title-line__title">
              <div
                :class="{
                  'content-title-line-state__orange': penPV.Activa,
                  'content-title-line-state__blue': !penPV.Activa,
                }"
              />
              {{ penPV.Partida.Articulo.Familia.Nombre }}
            </div>
            <div class="content-title-line__after">
              <div class="content-title-line__after--time">
                {{ `${FormatearFecha2(penPV.FechaEstado)} ${FormatearFecha(penPV.FechaEstado)}` }}
              </div>
            </div>
          </div>
          <div class="content-subtitle justify-content-space-between">
            <div class="display-flex align-items-center">
              <div
                class="content-subtitle__strong"
              >
                {{ `${penPV.Partida.Serie}/${FormatearIdentificadorPartida(penPV.Partida.Numero)}` }}
              </div>
              <div class="content-subtitle__gray">
                {{ penPV.PuntoVolcado.DescripcionCorta }}
              </div>
            </div>
            <div class="content-text">
              <span
                v-if="penPV.EntidadVolcada"
                :style="{ 'margin-right': '5px' }"
              >{{ penPV.EntidadVolcada.NumeroSerie }}</span>
            </div>
          </div>
          <div class="content-text">
            <span v-if="usoLotesMovilidad && penPV.Lote != null"> {{ `${$t('common.lot').toUpperCase()}:` }} </span>
            <span v-if="usoLotesMovilidad && penPV.Lote != null">{{ penPV.Lote.Codigo }}</span>
          </div>
          <div
            class="content-text"
          >
            <PCOperacionesPersonalizadas
              :tipo-entidad="1"
              :entidad="{ Id: penPV.Partida.Id }"
              formulario-padre="frmPaletizado"
              componente-aplicacion="PCPartidasActivasYRecientesLineaSinAsociacionPedido"
              :mostrar-precarga="false"
              :modo-consulta-agrupada="true"
              :datos="datosPartidasParaPersonalizaciones"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Popup Más Partidas Volcadas -->
    <f7-popup
      class="masPartidasVolcadas-popup"
      :opened="popupMasPartidasVolcadas"
      @popup:closed="CerrarMasPartidasVolcadas()"
    >
      <TheNavbar
        sliding
        :popup-close-btn-enable="true"
        :style="appTheme"
        :nav-title="$t('production.common.availableDumpedBatches')"
      />
      <UCPreload :show="mostrarPrecargaVerMas" />
      <div>
        <div>
          <div
            v-for="penPV in listadoPartidasTotalesEnPuntoVolcado"
            :key="penPV.Id"
            class="content-partida"
          >
            <div
              class="content-partida-item padding"
            >
              <div class="content-title-line">
                <div class="content-title-line__title">
                  <div
                    :class="{
                      'content-title-line-state__orange': penPV.Activa,
                      'content-title-line-state__blue': !penPV.Activa,
                    }"
                  />
                  {{ penPV.Partida.Articulo.Familia.Nombre }}
                </div>
                <div class="content-title-line__after">
                  <div class="content-title-line__after--time">
                    {{ `${FormatearFecha2(penPV.FechaEstado)} ${FormatearFecha(penPV.FechaEstado)}` }}
                  </div>
                </div>
              </div>
              <div class="content-subtitle justify-content-space-between">
                <div class="display-flex align-items-center">
                  <div class="content-subtitle__strong">
                    {{ `${penPV.Partida.Serie}/${FormatearIdentificadorPartida(penPV.Partida.Numero)}` }}
                  </div>

                  <div class="content-subtitle__gray">
                    {{ penPV.PuntoVolcado.DescripcionCorta }}
                  </div>
                </div>
                <div class="content-text">
                  <span
                    v-if="penPV.EntidadVolcada"
                    :style="{ 'margin-right': '5px' }"
                  >{{ penPV.EntidadVolcada.NumeroSerie }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="listadoPartidasTotalesEnPuntoVolcado != null && listadoPartidasTotalesEnPuntoVolcado.length > 5">
            <f7-button
              fill
              class="btn-color-gris-1 btn-tamaño-3 btn-cargarMasPartidas"
              @click="VerMasPartidasDeLaColaDeVolcado(cantidadRegistrosCargaVistaPopup + 50)"
            >
              {{ $t('common.loadMore').toUpperCase() }}
            </f7-button>
          </div>
        </div>
      </div>
    </f7-popup>

    <!-- Action Confirmación Resetear Partidas volcadas activas -->
    <f7-actions
      id="actions-ResetPartidasVolcadasActivas"
      class="action-restablecer-partidas"
      :opened="actionResetearPartidasVolcadasActivas"
      @actions:closed="actionResetearPartidasVolcadasActivas = false"
    >
      <div v-if="actionResetearPartidasVolcadasActivas">
        <span class="action-restablecer-partidas__title padding"> {{ $t('production.common.resetActiveBatches').toUpperCase() }} </span>
        <f7-actions-label class="text-align-center">
          <!-- El pedido seleccionado tiene palés reservados -->
          {{ $t('production.common.resetActiveBatchesConfirmation') }}
        </f7-actions-label>
        <!-- Pie de  Boton Opciones -->
        <div class="div-opcionesActions">
          <f7-row class="padding">
            <f7-col
              width="50"
              class="col-izquierdaActions"
            >
              <a
                class="link link-izquierdaActions-1"
                @click="actionResetearPartidasVolcadasActivas = false"
              >
                {{ $t('common.cancel').toUpperCase() }}
              </a>
            </f7-col>
            <f7-col
              width="50"
              class="col-derechaActions"
            >
              <a
                class="link link-derechaActions-1"
                @click="ResetearVolcadosActivos(true);actionResetearPartidasVolcadasActivas = false"
              >
                {{ $t('common.continue').toUpperCase() }}
              </a>
            </f7-col>
          </f7-row>
        </div>
      </div>
    </f7-actions>
  </div>
</template>

<script>
import { mapWritableState } from 'pinia';
import { useTraceabilityStore } from '@/js/stores/traceability';
import { useParamRef } from '@erpagroapp/params';

import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import TheNavbar from '@/components/TheNavbar.vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import SoporteNumeracion from '@/js/common/HiNumerationSupport';
import SoportePersonalizacion from '@/js/services/soportePersonalizacion';
import UCPreload from '@/components/common/UCPreload.vue';
import {
  HiDialog,
  HiNotification,
} from '@/js/common/HINotificationSupport';
import PCOperacionesPersonalizadas from './PCOperacionesPersonalizadas.vue';

export default {
  name: 'PCPartidasActivasYRecientesLineaSinAsociacionPedido',
  components: {
    UCPreload,
    TheNavbar,
    PCOperacionesPersonalizadas,
  },
  props: {
    intervaloActualizacionAutomatica: { type: Number, default: 0 }, // Se indica en Segundos y actualizara el resumen.
    puntoPaletizadoSeleccionado: { type: Object, default: null }, // Si se establece un punto se filtraran por los puntos de volcado asociados a cada punto de paletizado.
    lineaProduccionSeleccionada: { type: Object, default: null },
  },

  emits: [
    'partidasActivas',
    'inicioCargaDatos',
    'finCargaDatos',
  ],

  data() {
    return {
      // lineaProduccion: null,
      mostrarPrecarga: false, // Muestra el componente de carga del resumen.
      mostrarPrecargaVerMas: false, // Muestra la precarga del ver más.
      partidasEnPuntoDeVolcado: [],
      listadoPartidasTotalesEnPuntoVolcado: null, // Carga el listado de las X ultimas partidas cuando se pulsa en Ver Más.
      popupMasPartidasVolcadas: false, // Controla la apertura del popup  que muestra mas partidas volcadas.

      /**
       * Mantiene el timer que realiza las actualizaciones automaticas.
       * @type {ReturnType<typeof setTimeout> | null}
       */
      actualizadorAutomatico: null,

      actionResetearPartidasVolcadasActivas: false,
      cantidadRegistrosCargaVistaPopup: 50, // Cantidad de registro que carga en la vista de ver más.
      datosPartidasParaPersonalizaciones: [], // Contiene un listado de los datos de las partidas visualizadas para ser utilizado en la consulta de personalizaciones
      personalizacionTarjetaPartidasActiva: false,
      usoLotesMovilidad: useParamRef('UsoLotesMovilidad'),
    };
  },
  computed: {
    ...mapWritableState(useTraceabilityStore, ['partidasVisualizadas']),

    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-plum-shadow)',
        '--f7-navbar-text-color': '#fff',
      };
    },
  },
  watch: {
    puntoPaletizadoSeleccionado() {
      this.RestablecerValores();
      this.ActualizarDatos(true);
    },
    partidasEnPuntoDeVolcado(val) {
      this.$emit('partidasActivas', this.partidasEnPuntoDeVolcado.filter((item) => item.Activa).map((item) => item.Partida));
      if (val !== null && val.length > 0) {
        this.ObtenerPersonalizacionesPlanificaciones(val);
      }
    },
  },
  created() {
    this.InicializarComponente();
  },
  unmounted() {
    this.EliminarIntervaloActualizacionesAutomaticas();
  },
  methods: {
    InicializarComponente() {
      Log(this, this.InicializarComponente.name);
      if (this.intervaloActualizacionAutomatica > 0) {
        this.ProgramarIntervaloActualizacionesAutomaticas();
      }
      this.ActualizarDatos(true);
      this.ConfigurarPersonalizacionesFrm();
    },

    ActualizarDatos(mostrarPrecarga) {
      Log(this, this.ActualizarDatos.name);
      const self = this;
      if (this.lineaProduccionSeleccionada != null) {
        self.mostrarPrecarga = mostrarPrecarga !== undefined ? mostrarPrecarga : true;
        if (this.puntoPaletizadoSeleccionado != null) {
          this.ObtenerPartidasRecientesDeLaColaDeVolcadoXPuntoPaletizado(10).then((result) => {
            self.partidasEnPuntoDeVolcado = result;
            // Ordenar partidasEnPuntoDeVolcado por las partidas activas primero y por fecha descendente
            self.partidasEnPuntoDeVolcado.sort((a, b) => {
              if (a.PartidaActiva && !b.PartidaActiva) {
                return -1;
              }
              if (!a.PartidaActiva && b.PartidaActiva) {
                return 1;
              }
              if (a.FechaHora < b.FechaHora) {
                return 1;
              }
              if (a.FechaHora > b.FechaHora) {
                return -1;
              }
              return 0;
            });
            self.mostrarPrecarga = false;
          }).catch((error) => {
            self.mostrarPrecarga = false;
            HiNotification.Toast(error);
          });
        } else {
          // Filtramos todos los volcados de los puntos de volcado de la linea seleccionada.
          this.ObtenerPartidasRecientesDeLaColaDeVolcado(10).then((result) => {
            self.mostrarPrecarga = false;
            if (this.puntoPaletizadoSeleccionado != null) {
              return;
            } // No asignamos el resultado puesto que se esta a la espera de recibir la respuesta de ObtenerPartidasRecientesDeLaColaDeVolcadoXPuntoPaletizado
            self.partidasEnPuntoDeVolcado = result;
          }).catch((error) => {
            self.mostrarPrecarga = false;
            HiNotification.Toast(error);
          });
        }
      }
    },

    /**
     * @public
     * @returns {void}
     */
    RestablecerValores() {
      Log(this, this.RestablecerValores.name);
      this.partidasEnPuntoDeVolcado = [];
    },

    ConfigurarPersonalizacionesFrm() {
      Log(this, this.ConfigurarPersonalizacionesFrm.name);
      this.personalizacionTarjetaPartidasActiva = SoportePersonalizacion.ExistePersonalizacion('frmPaletizado', 'PCPartidasActivasYRecientesLineaSinAsociacionPedido');
    },

    async ObtenerPersonalizacionesPlanificaciones(lstPartidas) {
      Log(this, this.ObtenerPersonalizacionesPlanificaciones.name);
      if (!this.personalizacionTarjetaPartidasActiva) {
        return;
      } // Comprueba si esta activa.
      this.datosPartidasParaPersonalizaciones = [];
      const entidades = [];
      lstPartidas.forEach((e) => {
        const array = entidades.filter((f) => f.Id === e.Partida.Id);
        if (array.length < 1) {
          entidades.push({ Id: e.Partida.Id });
        }
      });

      /* lstPartidas.forEach((e) => {
        entidades.push({ Id: e.Partida.Id });
      }); */
      this.datosPartidasParaPersonalizaciones = await SoportePersonalizacion.ObtenerOperacionesPersonalizadasEntidadMultiple(entidades, 1, 'frmPaletizado', 'PCPartidasActivasYRecientesLineaSinAsociacionPedido');
    },
    /*
    ObtenerLineaDeProduccionSeleccionada() {
      Log(this,'PCPartidasActivasYRecientesLineaSinAsociacionPedido->ObtenerLineaDeProduccionSeleccionada');
      this.lineaProduccion = getLineaSeleccionada();
    },
    */

    FormatearFecha(fechaYHora) {
      return SoporteFechaYHora.obtenerHorasYMinutos(fechaYHora);
    },

    FormatearFecha2(fechaYHora) {
      return SoporteFechaYHora.ObtenerDiaMesAno(fechaYHora);
    },

    FormatearIdentificadorPartida(identificadorPartida) {
      return SoporteNumeracion.EstablecerLogitudFija(identificadorPartida, 7);
    },

    /**
     * @public
     * @returns {void}
     */
    VerMasPartidasDeLaColaDeVolcado(cantidadRegistrosCarga) {
      Log(this, this.VerMasPartidasDeLaColaDeVolcado.name);
      // En caso de no venir definido cargamos 50 registros.
      if (cantidadRegistrosCarga == null || undefined) {
        this.cantidadRegistrosCargaVistaPopup = 50;
        // this.mostrarPrecargaVerMas = true; // Solo mostramos la precarca total en el caso de que la carga es la inicial, en los cargar más no se muestra
      } else {
        this.cantidadRegistrosCargaVistaPopup = cantidadRegistrosCarga;
      }

      this.popupMasPartidasVolcadas = true;
      const self = this;

      if (this.lineaProduccionSeleccionada != null) {
        // Filtramos por volcados solo de los puntos de volcado asociados al punto paletizado seleccionado.
        if (this.puntoPaletizadoSeleccionado != null) {
          self.mostrarPrecargaVerMas = true;
          this.listadoPartidasTotalesEnPuntoVolcado = [];
          this.ObtenerPartidasRecientesDeLaColaDeVolcadoXPuntoPaletizado(this.cantidadRegistrosCargaVistaPopup).then((result) => {
            self.listadoPartidasTotalesEnPuntoVolcado = result;
            self.mostrarPrecargaVerMas = false;
          }).catch((error) => {
            self.mostrarPrecargaVerMas = false;
            HiNotification.Toast(error);
          });
        } else {
          // Filtramos todos los volcados de los puntos de volcado de la linea seleccionada.
          self.mostrarPrecarga = true;
          this.listadoPartidasTotalesEnPuntoVolcado = [];
          this.ObtenerPartidasRecientesDeLaColaDeVolcado(this.cantidadRegistrosCargaVistaPopup).then((result) => {
            self.listadoPartidasTotalesEnPuntoVolcado = result;
            self.mostrarPrecarga = false;
          }).catch((error) => {
            self.mostrarPrecarga = false;
            HiNotification.Toast(error);
          });
        }
      }
    },

    CerrarMasPartidasVolcadas() {
      Log(this, this.CerrarMasPartidasVolcadas.name);
      this.popupMasPartidasVolcadas = false;
      this.listadoPartidasTotalesEnPuntoVolcado = null;
    },

    ProgramarIntervaloActualizacionesAutomaticas() {
      Log(this, this.ProgramarIntervaloActualizacionesAutomaticas.name);
      // const self = this;
      this.actualizadorAutomatico = setInterval(
        () => {
          this.ActualizarDatos(false, false);
        },
        this.intervaloActualizacionAutomatica * 1000,
      );
    },

    EliminarIntervaloActualizacionesAutomaticas() {
      Log(this, this.EliminarIntervaloActualizacionesAutomaticas.name);
      if (this.actualizadorAutomatico) {
        clearInterval(this.actualizadorAutomatico);
      }
    },

    /**
     * @public
     * @returns {void}
     */
    ResetearVolcadosActivos(confirmacion) {
      Log(this, this.ResetearVolcadosActivos.name);
      // alert("Pendiente de implementar")
      if (!confirmacion) {
        this.actionResetearPartidasVolcadasActivas = true;
        return;
      }
      this.FinalizarPartidasActivasEnLaLineaDeProduccion(this.lineaProduccionSeleccionada.Id).catch((error) => {
        HiNotification.Toast(error);
      });
    },

    ObtenerPartidasRecientesDeLaColaDeVolcado(cantidadPartidasFinalizadasRecuperar) {
      Log(this, this.ObtenerPartidasRecientesDeLaColaDeVolcado.name);
      if (this.lineaProduccionSeleccionada === null) {
        return null;
      }
      this.$emit('inicioCargaDatos');
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerPartidasRecientesDeLaColaDeVolcado(this.lineaProduccionSeleccionada.Id, cantidadPartidasFinalizadasRecuperar).then((result) => {
          if (result.Valor) {
            const tempPartidas = JSON.parse(result.Mensaje);
            resolve(tempPartidas);
            this.partidasVisualizadas = tempPartidas; // Variable Global.
          } else {
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            LogError('error');
            reject(error);
          })
          .finally(() => {
            this.$emit('finCargaDatos');
          });
      });
    },
    ObtenerPartidasRecientesDeLaColaDeVolcadoXPuntoPaletizado(cantidadPartidasFinalizadasRecuperar) {
      Log(this, this.ObtenerPartidasRecientesDeLaColaDeVolcadoXPuntoPaletizado.name);
      if (this.puntoPaletizadoSeleccionado === null) {
        return null;
      }
      this.$emit('inicioCargaDatos');
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerPartidasRecientesDeLaColaDeVolcadoXPuntoPaletizado(this.puntoPaletizadoSeleccionado.Id, cantidadPartidasFinalizadasRecuperar).then((result) => {
          if (result.Valor) {
            const tempPartidas = JSON.parse(result.Mensaje);
            resolve(tempPartidas);
            this.partidasVisualizadas = tempPartidas; // Variable Global.
          } else {
            reject(result.Mensaje);
          }
        })
          .catch((error) => {
            LogError(this, this.ObtenerPartidasRecientesDeLaColaDeVolcadoXPuntoPaletizado.name, error);
            reject(error);
          })
          .finally(() => {
            this.$emit('finCargaDatos');
          });
      });
    },

    FinalizarPartidasActivasEnLaLineaDeProduccion(idLineaDeProduccion) {
      Log(this, this.FinalizarPartidasActivasEnLaLineaDeProduccion.name);
      const self = this;
      HiDialog.Preloader(true, this.$t('production.info.finishingActiveBatches'));
      this.contadorDeLlamadasPendientesDeRespuestaEnFrm += 1;
      return new Promise((resolve, reject) => {
        ConexionTA.callFinalizarPartidasActivasEnLaLineaDeProduccion(idLineaDeProduccion).then((result) => {
          if (result.Valor) {
            HiDialog.Preloader(false);
            resolve();
          } else {
            HiNotification.Toast(result.Mensaje);
            HiDialog.Preloader(false);
            reject();
          }
        })
          .catch(() => {
            HiDialog.Preloader(false);
            HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
            reject();
          })
          .finally(() => {
            self.contadorDeLlamadasPendientesDeRespuestaEnFrm -= 1;
          });
      });
    },
  },
};
</script>

<style lang="scss">
.col-indicadorEstadoVolcado {
  padding-top: 5px;
  padding-right: 10px;
}

.col-horaVolcadoPartida {
  text-align: -webkit-right;
  margin-right: 5px;
}

.div-registroPartida {
  padding-top: 8px;
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid var(--his-disabled);
}

.div-registrosDePartidasActivas {
  background: #fff;
}

.div-registrosDePartidasFinalizadas {
  background: #fafbfc;
}

.div-registrosDePartidasPopup {
  overflow-y: auto;
  height: 63vh;
}

.btn-cargarMasPartidas {
  margin-top: 10px;
}

.masPartidasVolcadas-popup {
  --f7-navbar-title-font-size: 18px;
  --f7-navbar-text-color: var(--his-steel-blue);

  overflow-y: scroll;
}

.action-restablecer-partidas {
  background: #fff;
  height: 24vh;

  &__title {
    display: flex;
    justify-content: center;
    color: var(--his-steel-blue);
    font-weight: 600;
  }
}
</style>
